import { setCanLoadMore, setFolders } from '../../actions/folders/actions';
import { notify } from '../../actions/notifications';
import { IFolderResponseSchema } from '../../repositories/favorites/entities/user_folder/FolderResponseSchema';
import { fetchGetFolders, IGetFoldersRequest, TGetFoldersResponse } from '../../repositories/favorites/v1/get-folders';
import { selectFolders } from '../../selectors/folders';
import { IFavoritesFolder } from '../../types/favoriteEntity';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';
import { getTextCount } from '../../utils/favoriteEntity';

interface IParameters {
  offset?: number;
  limit?: number;
  keepExisting?: boolean;
}

export const DEFAULT_LIMIT = 40;
const defaultParameters: IParameters = {
  offset: 0,
  limit: DEFAULT_LIMIT,
  keepExisting: false,
};

export const getFolders =
  (parameters?: IParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const { keepExisting, ...fetchParameters } = {
      ...defaultParameters,
      ...parameters,
    };
    const showError = () => dispatch(notify('Не получилось загрузить подборки', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TGetFoldersResponse = await fetchGetFolders({
        httpApi,
        parameters: fetchParameters as IGetFoldersRequest,
      });

      if (statusCode === 200) {
        let existingFolders: IFavoritesFolder[] = [];
        if (keepExisting) {
          existingFolders = selectFolders(getState()) || [];
        }

        const folders =
          response.folders?.map((folderItem: IFolderResponseSchema) => ({
            ...folderItem,
            description: getTextCount(folderItem.offersCount),
          })) || [];
        dispatch(setFolders({ folders: [...existingFolders, ...folders] }));
        dispatch(setCanLoadMore({ value: response.page.canLoadMore }));
      }

      if (statusCode === 400) {
        logger.warning(response.message || 'Failed to get favorites folders (400 status code)');
        showError();
      }
    } catch (e) {
      logger.error(e, { description: 'Failed to get favorites folders' });
      showError();
    }
  };
